<template>
<div>
    <ob-modal2 :show.sync="show" :backdrop="false">
       <template slot="modal-title">
    {{IsEdit ? "Update" : "Add"}} Home Address
    </template>
    <template slot="modal-body">
      <div class="add_task">
        <div class="row">
          <div class="form-group col-md-6">
            <label>Address Line 1</label><span class="validation-star">*</span>
            <ob-input v-model="addressLine1" placeholder="Enter Address Line 1" :class="{ 'ob-vuelidate_input-error': $v.addressLine1.$error }" ></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.addressLine1.$dirty && !$v.addressLine1.required">Enter Address Line 1</span>
          </div>
          <div class="form-group col-md-6">
            <label>Address Line 2</label>
            <ob-input v-model="addressLine2" placeholder="Enter Address Line 2" :class="{ 'ob-vuelidate_input-error': $v.addressLine2.$error }"></ob-input>
            <!-- <span class="ob-vuelidate_error-msg" v-if="$v.addressLine2.$dirty && !$v.addressLine2.required">Enter Address Line 2</span> -->
          </div>
        </div>
          <div class="row">
          <div class="form-group col-md-6">
            <label>City,State <i class="fa fa-info-circle" v-tooltip="'Please enter atleast first two letters of your City and select options listed.'"></i></label><span class="validation-star">*</span>
            <location-search  v-model.trim="Location"  :inModal ="true" :vmodelData.sync="Location" @input="getZipCode(Location)"></location-search>
            <span class="ob-vuelidate_error-msg" v-if="$v.Location.$dirty && !$v.Location.required">Enter City,State</span>
          </div>
          <div class="form-group col-md-6">
            <label>Zipcode</label><span class="validation-star">*</span>
            <ob-input v-model="zipcode" placeholder="Enter Zipcode" :class="{ 'ob-vuelidate_input-error': $v.zipcode.$error }"></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="$v.zipcode.$dirty && !$v.zipcode.required">Enter Zipcode</span>
          </div>
        </div>
          <div class="row">
            <div class="col-md-12 form-group ">
              <div class="col-md-6 pL0" style="padding-right:5px;">
                <label>Period of Stay (From)</label>
                <ob-date-time-picker ref="stayFromDate" v-model = "stayFromDate" class="offer-input" id="stayFromDate" placeholder="From date" :inputvalue="stayFromDate" :options="datePickerOptions" @updated="(v) => this.stayFromDate = v" :dpchange="onCreatedFrom"></ob-date-time-picker>
                <!-- <span class="ob-vuelidate_error-msg" v-if="$v.stayFromDate.$dirty && !$v.stayFromDate.requiredIf">Select From date for Period of stay</span> -->
              </div>
              <div class="col-md-6 ">
                <label>Period of Stay (To)</label>
                <ob-date-time-picker ref="stayToDate" class="offer-input" v-model = "this.stayToDate" id="stayToDate" placeholder="To date" :inputvalue="stayToDate" :options="datePickerOptions" @updated="(v) => this.stayToDate = v"></ob-date-time-picker>
              </div>
            </div>
          </div>
          <div>
              <ob-checkbox v-model="CurrentHomeAddress">Mark as current home address</ob-checkbox>
          </div>
      </div>
    </template>
    <template slot="modal-footer">
      <ob-button type="secondary" @click="show = false">Cancel</ob-button>
      <ob-button  @click="isValid()">{{IsEdit ? "Update" : "Add"}}</ob-button>
    </template>
    </ob-modal2>

    </div>
</template>
<script>
import { required,requiredIf} from 'vuelidate/lib/validators'
    export default {
        props: ["openModal", "IsEdit", "PreviousData", "EmpId"],
        data(){
         return {
          CurrentHomeAddress:false,
          Location:"",
          show: false,
          Id:'',
          addressLine1 :'',
          addressLine2:'',
          zipcode :'',
          stayFromDate:'',
          stayToDate:'',
          datePickerOptions: {
          format: 'MM/DD/YYYY'
            },
           }
          },
        watch: {
            openModal(val) { 
                this.show = val;
                  this.resetValues()
                  if(val) { // On Modal Open
                  //  this.resetValues()
                  if(this.IsEdit){
                  this._previousData()
                  }
        
                }
            },
            show(val) {
                this.$emit('update:openModal', val)
            },
        },
        computed: {
            
        },
        created()
        {
           this.show = this.openModal
           this.resetValues()
           if(this.IsEdit){
           this._previousData()
           }
        },
        
      methods: {
      resetValues(){
      this.Id = '';
      this.addressLine1 = '';
      this.addressLine2 = '',
      this.Location ='',
      this.zipcode = '',
      this.stayFromDate ='',
      this.stayToDate = '',
      this.CurrentHomeAddress = false;
      this.$v.zipcode.$reset();
      this.$v.Location.$reset();
      this.$v.addressLine2.$reset();
      this.$v.addressLine1.$reset();
      //this.$v.stayFromDate.$reset();
    },
    _previousData(){
       var x = this.PreviousData.AddressSummary
       this.Id = this.PreviousData.Id
       this.addressLine1 = this.PreviousData.Address1
       this.addressLine2 = this.PreviousData.Address2
       if(x == ","){
         this.Location = ''
       }
       else this.Location = x 
       this.zipcode = this.PreviousData.ZipCode
       this.stayFromDate = this.PreviousData.PeriodOfStayFrom
       this.stayToDate   =  this.PreviousData.PeriodOfStayTo
       this.CurrentHomeAddress = this.PreviousData.IsCurrentAddress
    },
    isValid() {
      this.$v.addressLine1.$touch();
      // this.$v.addressLine2.$touch();
      this.$v.Location.$touch();
      this.$v.zipcode.$touch();
      //this.$v.stayFromDate.$touch();
       if(this.$v.addressLine1.$error == false && this.$v.Location.$error == false && this.$v.zipcode.$error == false){
        this.$loading({
          'loadingText': 'Loading...'
        })
         let LocationString = this.Location
        let res = LocationString.split(",")
        let City = res[0]
        let State = res[1]
    
          var Obj =  {
          "Id":this.Id,
          "Address1": this.addressLine1,
          "Address2": this.addressLine2,
           "City":City,
           "State": State,
        //   "AddressSummary"   : this.Location,
         "ZipCode"     : this.zipcode,
          "PeriodOfStayFrom"  : this.stayFromDate,
          "PeriodOfStayTo"  : this.stayToDate,
          "IsCurrentAddress": this.CurrentHomeAddress,
         }
         if(this.IsEdit){
          this.EditHomeContact(Obj)
        }else{
          this.addHomeAddress(Obj)
        }      
       this.show = false
       this.$emit('close')
      }
      else{
        this.show = true
      }
     
    },
    onCreatedFrom(e) {
    this.$refs.stayToDate.data.minDate(e.date)
    },
    cancel(){
      this.show = false
      this.$emit('close')
    },
    getZipCode(l){
        setTimeout(() =>{
            if(this.Location != ''){
                ajax.get(`/Account/GetZipCode?location=${l}`,{},(res) =>{
                    this.zipcode = res.data.ZipCodeModel.ZipCode
                })
            }
            else
                this.zipcode = ''
        },100)           
    },
    addHomeAddress(obj){
        ajax.put(`Employee/${this.EmpId}/AddAddress?loggedInOrgId=${this.loggedInUserObj.orgId}`,obj, (res) => {
        if(res.data.State == true) {
          this.$parent.getEmployeeDatails() 
          this.$message({
            type: 'success',
            message: "Home Address Added Successfully"
          });
          this.$loading({}).close();
        }else if(res.data.State == false){
          this.$loading({}).close();
          this.$message({
              type: 'error',
              message: res.data.Message
          });
        }
      });
    },
    EditHomeContact(obj){
        ajax.put(`Employee/${this.EmpId}/UpdatePreviousAddress?loggedInOrgId=${this.loggedInUserObj.orgId}`,obj, (res) => {
        if(res.data.State == true) {
          this.$parent.getEmployeeDatails()
          this.$message({
            type: 'success',
            message: "Home Address Updated Successfully"
          });
          this.$loading({}).close();
        }else if(res.data.State == false){
          this.$loading({}).close();
          this.$message({
              type: 'error',
              message: res.data.Message
          });
        }
      });
    }
              
        },
    validations() {
     return{
      Location:{
          required
      },
       
      "addressLine1":{
        required
      },
      "addressLine2":{
        required
      },
     "zipcode":{
        required
      },
      //  "stayFromDate":{
      //   requiredIf:requiredIf(() =>{
      //               if(this.addressLine1 != '' || this.addressLine2 != '' && this.stayFromDate == ''){
      //                   return true
      //                 }
      //                 else{
      //                       return false
      //                     }
      //           })
      // },
    }
  },
    }
</script>




// WEBPACK FOOTER //
// src/components/ESSProfile/AddHomeContact.vue